export enum CreatorType
{
    hcp="HCP",
    ent="ENT",
    admin="Admin"
}

